import { Box, Checkbox } from '@mui/material'
import { useAppTheme } from '@/theme/ThemeContext'

const SHOW_CLOSED_LABEL = 'הצג תוצאות סגורות'

/** The alert lists' "show closed" box, shaped to sit in a FilterToolbar custom field. */
const ShowClosedCheckbox = ({
  checked,
  onChange,
}: {
  checked: boolean
  onChange: (checked: boolean) => void
}) => {
  const { mode } = useAppTheme()
  const isDarkMode = mode === 'dark'
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: isDarkMode ? '#BBD7FF' : '#003F61',
        fontFamily: 'Rubik, sans-serif',
        fontSize: 'clamp(12px, 0.9vw, 14px)',
      }}
    >
      <Box component="span">{SHOW_CLOSED_LABEL}</Box>
      <Checkbox
        checked={checked}
        onChange={event => onChange(event.target.checked)}
        inputProps={{ 'aria-label': SHOW_CLOSED_LABEL }}
        sx={{
          color: isDarkMode ? '#4B6FB1' : '#C0C2D6',
          '&.Mui-checked': { color: isDarkMode ? '#BBD7FF' : '#003F61' },
        }}
      />
    </Box>
  )
}

export default ShowClosedCheckbox
